import { render } from "./MenuSub.vue?vue&type=template&id=48bbd207&ts=true"
import script from "./MenuSub.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuSub.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/menu/MenuSub.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48bbd207"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48bbd207', __exports__)) {
    api.reload('48bbd207', __exports__)
  }
  
  module.hot.accept("./MenuSub.vue?vue&type=template&id=48bbd207&ts=true", () => {
    api.rerender('48bbd207', render)
  })

}


export default __exports__